import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { Organization, OrganizationDefaultValues } from 'src/app/components/organization/org';
import { OrganizationService } from 'src/app/services/organization.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-edit-org',
    templateUrl: './edit-org.component.html',
    styleUrls: ['./edit-org.component.scss'],
    standalone: false
})
export class EditOrgComponent {

  org:Organization=OrganizationDefaultValues();
  isSubmitted=false
  pageName = CheckPageAccess.ORGMANAGEMENT
  constructor(private _orgservice:OrganizationService,private route:ActivatedRoute,private _toastservice:ToastService,private router:Router) { } 

  ngOnInit()
  {
    this.route.params.subscribe(params=>{
      this._orgservice.getOrgDetailsForUpdate(params['id']).subscribe({
        next:(data)=>{
          this.org=data;
        }
      })
    })
    
  }

  onSubmit()
  {
    this.isSubmitted=true;
    this._orgservice.updateOrg(this.org).subscribe({
      next:(data)=>
      {
          this._toastservice.showMessage("Organization Updated Successfully");
          this.router.navigateByUrl('/org-list');
      }
    })
  }

}
